export default __webpack_public_path__ + "static/media/(94).a93c6ca2.jpg";